<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('banner.bannerImage')" prop="bannerUrlIn">
        <file-upload type="image" :value="form.bannerUrlIn" :count="1" @change="coverHandleIn"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.bannerUrlIn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUploadIn"-->
<!--          :customRequest="handleChangeIn"-->
<!--        >-->
<!--          <div v-if="form.bannerUrlIn" class="upload-image-wrapper">-->
<!--            <img v-if="form.bannerUrlIn" :src="form.bannerUrlIn" alt="logo"-->
<!--                 style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoadingIn" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoadingIn ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('banner.uploadImage') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>



      <a-form-model-item :label="$t('banner.bannerImageEn')" prop="bannerUrlEn">
        <file-upload type="image" :value="form.bannerUrlEn" :count="1" @change="coverHandleEn"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.bannerUrlEn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUploadEn"-->
<!--          :customRequest="handleChangeEn"-->
<!--        >-->
<!--          <div v-if="form.bannerUrlEn" class="upload-image-wrapper">-->
<!--            <img v-if="form.bannerUrlEn" :src="form.bannerUrlEn" alt="logo"-->
<!--                 style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoadingEn" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('banner.uploadImage') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>

      <a-form-model-item :label="$t('banner.bannerImageCn')" prop="bannerUrlCn">
        <file-upload type="image" :value="form.bannerUrlCn" :count="1" @change="coverHandleCn"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.bannerUrlCn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUploadCn"-->
<!--          :customRequest="handleChangeCn"-->
<!--        >-->
<!--          <div v-if="form.bannerUrlCn" class="upload-image-wrapper">-->
<!--            <img v-if="form.bannerUrlCn" :src="form.bannerUrlCn" alt="logo"-->
<!--                 style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoadingCn" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoadingCn ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('banner.uploadImage') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>

      <a-form-model-item :label="$t('banner.bannerImageArabic')" prop="bannerUrl">
        <file-upload type="image" :value="form.bannerUrl" :count="1" @change="coverHandleZhengchang"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.bannerUrl"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload"-->
<!--          :customRequest="handleChange"-->
<!--        >-->
<!--          <div v-if="form.bannerUrl" class="upload-image-wrapper">-->
<!--            <img v-if="form.bannerUrl" :src="form.bannerUrl" alt="logo"-->
<!--                 style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('banner.uploadImage') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>
      <a-form-model-item :label="$t('banner.video')" prop="videoUrlIn">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrlIn"
          :showUploadList="false"
          :customRequest="handleVideoIn"
        >
          <div v-if="form.videoUrlIn">
            <video :src="form.videoUrlIn" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingIn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('banner.upload') }}</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadInSize!= 0" :percent=this.uploadInSize />
      </a-form-model-item>
      <a-form-model-item :label="$t('banner.videoEn')" prop="videoUrlEn">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrlEn"
          :showUploadList="false"
          :customRequest="handleVideoEn"
        >
          <div v-if="form.videoUrlEn">
            <video :src="form.videoUrlEn" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingEn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('banner.upload') }}</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadEnSize!= 0" :percent=this.uploadEnSize />
      </a-form-model-item>
      <a-form-model-item :label="$t('banner.videoCn')" prop="videoUrlCn">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrlCn"
          :showUploadList="false"
          :customRequest="handleVideoCn"
        >
          <div v-if="form.videoUrlCn">
            <video :src="form.videoUrlCn" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingCn ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('banner.upload') }}</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadCnSize!= 0" :percent=this.uploadCnSize />
      </a-form-model-item>

      <a-form-model-item :label="$t('banner.videoArabic')" prop="videoUrl">
        <a-upload
          listType="picture-card"
          accept=".mp4"
          class="avatar-uploader"
          v-model="form.videoUrl"
          :showUploadList="false"
          :customRequest="handleVideo"
        >
          <div v-if="form.videoUrl">
            <video :src="form.videoUrl" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">{{ $t('banner.upload') }}</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if=" this.uploadSize!= 0" :percent=this.uploadSize />
      </a-form-model-item>



      <a-form-model-item :label="$t('banner.sort')" prop="sort">
        <a-input v-model="form.sort" :placeholder="$t('banner.inputSort')"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('banner.type')" prop="imgType">
        <a-select :placeholder="$t('banner.selectType')" v-model="form.imgType">
          <a-select-option :key="0">{{ $t('banner.bannerType') }}</a-select-option>
          <a-select-option :key="1">{{ $t('banner.adType') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('banner.jumpType')" prop="type">
        <a-select :placeholder="$t('banner.selectJumpType')" @change="updateType" v-model="form.type">
          <a-select-option :key="0">{{ $t('banner.video') }}</a-select-option>
          <a-select-option :key="1">{{ $t('banner.externalLink') }}</a-select-option>
          <a-select-option :key="2">{{ $t('banner.rechargePage') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==0" :label="$t('banner.isJump')" prop="isJump">
        <a-select :placeholder="$t('banner.selectIsJump')" @change="updateIsGo" v-model="form.isJump">
          <a-select-option :key="false">{{ $t('common.no') }}</a-select-option>
          <a-select-option :key="true">{{ $t('common.yes') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="this.type==1" :label="$t('banner.externalLinkUrl')" prop="linkUrl">
        <a-input v-model="form.linkUrl" :placeholder="$t('banner.inputExternalLink')"/>
      </a-form-model-item>
      <a-form-model-item v-if="this.isJup && this.type==0" :label="$t('banner.video')" prop="videoId">
        <a-select
          v-model="form.videoId"
          showSearch
          style="width: 100%"
          :placeholder="$t('banner.selectVideo')"
          allow-clear
          optionFilterProp="children"
        >
          <a-select-option :value="item.id" :key="item.id" :title="item.videoNameIn" v-for="(item,index) in listAll">
            {{ item.videoNameIn }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getBanner, addBanner, updateBanner} from '@/api/banner/banner'
import {listVideo} from "@/api/video/video";
import UploadFileToVOD from "@/api/vod.js"
import UploadFileToOSS from "@/utils/upload-file-to-oss";

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      uploadLoading: false,
      uploadLoadingEn: false,
      uploadLoadingIn: false,
      uploadLoadingCn: false,
      process: false,
      formTitle: '',
      uploadSize: 0,
      uploadEnSize: 0,
      uploadInSize: 0,
      uploadCnSize: 0,
      fileList: [],
      type: 0,
      listAll: [],
      isJup: false,
      // 表单参数
      form: {
        id: null,

        sort: null,

        videoId: null,

        isJump: false,
        linkUrl: null,
        videoUrl: null,
        videoUrlEn: null,
        videoUrlIn: null,
        videoUrlCn: null,
        bannerType: null,
        imgType: null,
        type: null,

        bannerUrl: null,
        bannerUrlEn: null,
        bannerUrlIn: null,
        bannerUrlCn: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
    }
  },
  filters: {},
  created() {
    this.getGather();
    this.uploadSize = 0
    this.uploadEnSize = 0
  },
  computed: {
    rules() {
      return {
        sort: [
          {required: true, message: this.$t('banner.sortRequired')}
        ],
        isJump: [
          {required: true, message: this.$t('banner.isJumpRequired')}
        ],
        linkUrl: [
          {required: true, message: this.$t('banner.linkUrlRequired')}
        ],
        bannerUrl: [
          {required: true, message: this.$t('banner.bannerUrlRequired')}
        ]
      }
    }
  },
  watch: {},
  mounted() {
  },

  methods: {
    coverHandleIn(val) {
      this.form.bannerUrlIn = val;
    },
    coverHandleEn(val) {
      this.form.bannerUrlEn = val;
    },
    coverHandleCn(val) {
      this.form.bannerUrlCn = val;
    },
    coverHandleZhengchang(val) {
      this.form.bannerUrl = val;
    },
    handleChange(info) {
      let that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.bannerUrl = fileName[0];//文件名
          that.uploadLoading = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('bannerUrl')
            }
          })
        },
        error: function () {
          that.uploadLoading = false;
          that.$message.error(that.$t('banner.uploadFailed'));
        }
      });
    },

    handleChangeEn(info) {
      let that = this
      that.uploadLoadingEn = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.bannerUrlEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('bannerUrlEn')
            }
          })
        },
        error: function () {
          that.uploadLoadingEn = false;
          that.$message.error(that.$t('banner.uploadFailed'));
        }
      });
    },

    handleChangeIn(info) {
      let that = this
      that.uploadLoadingIn = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.bannerUrlIn = fileName[0];//文件名
          that.uploadLoadingIn = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('bannerUrlIn')
            }
          })
        },
        error: function () {
          that.uploadLoadingIn = false;
          that.$message.error(that.$t('banner.uploadFailed'));
        }
      });
    },

    handleChangeCn(info) {
      let that = this
      that.uploadLoadingCn = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.bannerUrlCn = fileName[0];//文件名
          that.uploadLoadingCn = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('bannerUrlCn')
            }
          })
        },
        error: function () {
          that.uploadLoadingCn = false;
          that.$message.error(that.$t('banner.uploadFailed'));
        }
      });
    },

    handleVideo(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      let that = this

      that.form.videoUrl = ""
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //
      //     that.form.videoUrl = fileName[0].url;//文件名
      //     that.uploadLoading = false;
      //   },
      //   vProgress: function (val) {
      //     that.uploadSize = val * 100;
      //   }
      // });

      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrl = fileName[0];//文件名
          that.uploadLoading = false;
          that.uploadSize = 0; // 上传成功后重置进度条
        },
        error: function () {
          that.uploadLoading = false;
          that.uploadSize = 0; // 上传失败后重置进度条
          that.$message.error(that.$t('banner.uploadFailed'));
        },
        vProgress: function (val) {
          that.uploadSize = val * 100;
        }
      });

    },

    handleVideoEn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingEn = true;
        return;
      }
      let that = this

      that.form.videoUrlEn = ""
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //
      //     that.form.videoUrlEn = fileName[0].url;//文件名
      //     that.uploadLoadingEn = false;
      //   },
      //   vProgress: function (val) {
      //     that.uploadEnSize = val * 100;
      //   }
      // });
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrlEn = fileName[0];//文件名
          that.uploadLoadingEn = false;
          that.uploadEnSize = 0; // 上传成功后重置进度条
        },
        error: function () {
          that.uploadLoadingEn = false;
          that.uploadEnSize = 0; // 上传失败后重置进度条
          that.$message.error(that.$t('banner.uploadFailed'));
        },
        vProgress: function (val) {
          that.uploadEnSize = val * 100;
        }
      });

    },

    handleVideoIn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingIn = true;
        return;
      }
      let that = this

      that.form.videoUrlIn = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrlIn = fileName[0];//文件名
          that.uploadLoadingIn = false;
          that.uploadInSize = 0; // 上传成功后重置进度条
        },
        error: function () {
          that.uploadLoadingIn = false;
          that.uploadInSize = 0; // 上传失败后重置进度条
          that.$message.error(that.$t('banner.uploadFailed'));
        },
        vProgress: function (val) {
          that.uploadInSize = val * 100;
        }
      });

    },

    handleVideoCn(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingCn = true;
        return;
      }
      let that = this

      that.form.videoUrlCn = ""
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.videoUrlCn = fileName[0];//文件名
          that.uploadLoadingCn = false;
          that.uploadCnSize = 0; // 上传成功后重置进度条
        },
        error: function () {
          that.uploadLoadingCn = false;
          that.uploadCnSize = 0; // 上传失败后重置进度条
          that.$message.error(that.$t('banner.uploadFailed'));
        },
        vProgress: function (val) {
          that.uploadCnSize = val * 100;
        }
      });

    },

    updateType(value) {
      this.type = value
    },
    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('banner.uploadImageWarning'));
        this.uploadLoading = false
        return false;
      }
      this.form.bannerUrl = ''
      this.uploadLoading = true
      //TODO 驗證文件大小
    },
    beforeUploadEn: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('banner.uploadImageWarning'));
        this.uploadLoadingEn = false
        return false;
      }
      this.form.bannerUrlEn = ''
      this.uploadLoadingEn = true
      //TODO 驗證文件大小
    },
    beforeUploadIn: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('banner.uploadImageWarning'));
        this.uploadLoadingIn = false
        return false;
      }
      this.form.bannerUrlIn = ''
      this.uploadLoadingIn = true
      //TODO 驗證文件大小
    },
    beforeUploadCn: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('banner.uploadImageWarning'));
        this.uploadLoadingCn = false
        return false;
      }
      this.form.bannerUrlCn = ''
      this.uploadLoadingCn = true
      //TODO 驗證文件大小
    },
    updateIsGo(value) {
      this.isJup = value
    },
    onClose() {
      this.isJup = false
      this.uploadSize = 0
      this.uploadEnSize = 0
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    getGather() {
      listVideo({isRelease: 1}).then(res => {
        this.listAll = res.data;
      })
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        sort: null,
        videoId: null,
        isJump: null,
        videoUrl: null,
        videoUrlEn: null,
        bannerUrl: null,
        bannerUrlEn: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBanner({"id": id}).then(response => {
        this.form = response.data
        this.isJup = this.form.isJump
        this.type = this.form.type
        var fal = 0;
        for (var element of this.listAll) {
          if (element.id === this.form.videoId) {
            fal = 1
          }
        }
        if (fal == 0) {
          this.form.videoId=''
        }
        this.open = true
        this.formTitle = this.$t('common.edit')
      })


    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBanner(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBanner(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
